import { validPasscode } from '../../data/passcode';
import { breachedPassword, lockoutPassword, reusedPassword, validPassword } from '../../data/password';

import serverErrorsJson from './server-errors.json';
import { DefaultBodyType, HttpResponse, StrictRequest } from 'msw';

type ServerErrorKey = keyof typeof serverErrorsJson;

type ValidatorOutput = ServerErrorKey | null;

interface Validator<T> {
    (arg: T): ValidatorOutput;
}

export const composeValidators = <T>(...validators: Validator<T>[]): Validator<T> => {
    return (arg: T) => {
        for (const v of validators) {
            const result = v(arg);
            if (result) {
                return result;
            }
        }

        return null;
    };
};
export const validateEmailOrPassword: Validator<string> = password => {
    return ![validPassword, process.env.NX_ACCOUNT_DEFAULT_PASSWORD].includes(password)
        ? 'incorrectEmailOrPassword'
        : null;
};

export const validatePassword: Validator<string> = password => {
    return ![validPassword, process.env.NX_ACCOUNT_DEFAULT_PASSWORD].includes(password) ? 'incorrectPassword' : null;
};

export const validateMaxPasswordAttempts: Validator<string> = password => {
    return password === lockoutPassword ? 'maxFailedAuthenticationAttempts' : null;
};

export const validateBreachedPassword: Validator<string> = password => {
    return password === breachedPassword ? 'breachedPassword' : null;
};

export const validateReusedPassword: Validator<string> = password => {
    return password === reusedPassword ? 'reusedPassword' : null;
};

export const validateNewPassword = composeValidators(validateBreachedPassword, validateReusedPassword);

export const validateCurrentPassword = composeValidators(validateMaxPasswordAttempts, validateEmailOrPassword);

export const validatePasswordInSettingsFlow = composeValidators(validateMaxPasswordAttempts, validatePassword);

export const validatePasscode: Validator<string> = passcode => {
    return passcode === validPasscode ? null : 'otpValidation';
};

export const getServerError = (serverErrorKey: ServerErrorKey) => serverErrorsJson[serverErrorKey];

export const validateOtp = composeValidators(validatePasscode);

export const otpHandler = async ({ request }) => {
    const body = await request.json();
    const error = validateOtp(body.passcode);
    return error ? composeServerError(request, error) : HttpResponse.json(body);
};

export function composeServerError(request: StrictRequest<DefaultBodyType>, serverErrorKey: ServerErrorKey) {
    const errorDetails = getServerError(serverErrorKey);
    const path = new URL(request.url).pathname;
    return HttpResponse.json(
        {
            timestamp: 1665743665396,
            path,
            ...errorDetails
        },
        { status: errorDetails.status }
    );
}
